var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal modal-bottom",on:{"click":_vm.onClose}},[_c('div',{staticClass:"modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"modal-body"},[_vm._t("body")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }